export const selectApprovalTabCounts = state => ({ ...state.approvalTabCounts.tabs })

export const selectApprovalTabCountsStatusProps = state => {
  const { fetching, fetched, error } = state.approvalTabCounts
  return { fetching, fetched, error }
}
